// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3g-0";
export var eligibilityCardNotEligible = "_3g-1";